import $ from 'jquery';
import Mustache from 'mustache';

class MustacheComponent
{
    constructor($template)
    {
        this.template = $template;
        this.data = {};
    }

    set(data)
    {
        this.data = data;
    }

    extend(data)
    {
        this.data = $.extend({}, this.data, data);
    }

    prepare()
    {
        return this.data;
    }

    change($template)
    {
        this.template = $template;
        this.data = {};
    }

    render()
    {
        const data = this.prepare();
        const template = this.template;
        const html = Mustache.to_html(template.html(), data);

        return html;
    }
}

export default MustacheComponent;



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/components/mustache-component.js